import styled, { keyframes } from 'styled-components';
import SectionContainer from '../../components/SectionContainer';

const fadeIn = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  } to {
    opacity: 0;
  }
`;

export const SearchPageNothingFound = styled.h2`
  width: 100%;
  margin: 100px 0;
  
  font-size: 40px;
  line-height: 1;
  text-align: center;
  opacity: 0.4;
  
  pointer-events: none;
  user-select: none;
`;

export const SearchPageContainer = styled(SectionContainer)`
  flex-grow: 1;
  align-items: flex-start;
  padding: 0 10px;
  padding-bottom: 60px;
  
  @media(min-width: 700px) {
    max-width: 975px;
    padding-bottom: 80px;
  }
  
  @media(min-width: 1024px) {
    max-width: 975px;
    padding-bottom: 120px;
  }
`;

export const CurrentVisitors = styled.p`
  margin: 0;
  margin-top: 30px;
  margin-bottom: 15px;
  padding: 0;
  
  font-size: 12px;
  color: ${({ theme }) => theme.black};
  
  b {
    margin-left: 5px;
  }
  
  svg {
    vertical-align: middle;
    margin-right: 10px;
  }
  
  @media(min-width: 700px) {
    margin-bottom: 25px;
    
    font-size: 16px;
  }
  
  @media(min-width: 900px) {
    margin-bottom: 40px;
  }
`;

export const SearchList = styled.ul`
  width: 100%;
  margin-bottom: 25px;
  
  @media(min-width: 700px) {
    margin-bottom: 40px;
  }
`;

export const SearchItem = styled.li`
  list-style: none;
  
  &.hotel-card-enter-active {
    animation: ${fadeIn} 0.25s forwards;
  }
  
  &.hotel-card-exit-active {
    animation: ${fadeOut} 0.25s forwards;
  }
  
  &.hotel-card-normal-enter-active {
    animation: ${fadeOut} 0.25s forwards;
  }
  
  &.hotel-card-normal-exit-active {
    animation: ${fadeIn} 0.25s forwards;
  }
  
  &:not(:last-child) {
    margin-bottom: 10px;
  }
  
  @media(min-width: 700px) {
    &:not(:last-child) {
      margin-bottom: 30px;
    }
  }
`;
